module.exports = __webpack_public_path__ + "img/laporan.c4589b06.svg";